import React, { FC } from 'react';

import { ChromeIcon } from '@modernloop/shared/icons';
import { Box, Typography } from '@mui/material';

import HelpCenterUrl from 'src/constants/HelpCenterUrl';

import AppWideBanner from './AppWideBanner';

interface MissingChromeExtensionBannerProps {
  text: string | JSX.Element;
  bannerUrlText?: string | null; // Defaults to 'Read more'
}

const MissingChromeExtensionBanner: FC<MissingChromeExtensionBannerProps> = ({ text, bannerUrlText }) => {
  const linkJSX = (
    <Box
      component="a"
      sx={{
        color: (theme) => theme.palette.primary.main,
        marginLeft: '2px',
        textDecoration: 'underline',
      }}
      href={HelpCenterUrl.CHROME_EXTENSION}
      target="_blank"
      rel="noreferrer"
    >
      {bannerUrlText}
    </Box>
  );
  const textJsx = (
    <Typography component="span">
      {text} {linkJSX}
    </Typography>
  );

  return (
    <AppWideBanner
      text={
        <Typography component="span" sx={{ gap: '8px', display: 'inline-flex', alignItems: 'center' }}>
          <ChromeIcon />
          {textJsx}
        </Typography>
      }
      backgroundColor="alternate"
      showClose
    />
  );
};

export default MissingChromeExtensionBanner;
